<div class="row">

    <div *ngIf="chartOptionsType" class="col">
        <div class="card mt-2 column" style="height: 100%;">
            <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <div class="column">
                    <h6 class="m-0">{{selectedToggle == 'COMPRA' ? 'Compras' : 'Ventas'}} por tipo</h6>
                    <div id="by-type-chart">
                        <apx-chart
                          [series]="chartOptionsType.series"
                          [chart]="chartOptionsType.chart"
                          [labels]="chartOptionsType.labels"
                          [responsive]="chartOptionsType.responsive"
                          [colors]="chartOptionsType.colors"
                          [plotOptions]="chartOptionsType.plotOptions"
                        ></apx-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div *ngIf="chartOptionsYear" class="col">
        <div class="card mt-2 column" style="height: 100%;">
            <div class="card-header d-flex justify-content-between align-items-center bg-transparent border-bottom-0">
                <div class="column">
                    <h6 class="m-0">{{selectedToggle == 'COMPRA' ? 'Compras' : 'Ventas'}} por año</h6>
                    <div id="by-year-chart">
                        <apx-chart
                          [series]="chartOptionsYear.series"
                          [chart]="chartOptionsYear.chart"
                          [labels]="chartOptionsYear.labels"
                          [responsive]="chartOptionsYear.responsive"
                          [colors]="chartOptionsYear.colors"
                        ></apx-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</div>
